import { Info } from "lucide-react";

import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";

import { getRuntimeVariableMetadata } from "./runtimeVariableMetadata";

export function RuntimeVariableInfo({ name }: { name: string }) {
  const metadata = getRuntimeVariableMetadata(name);

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          type="button"
          aria-label={`About ${name}`}
          className="inline-flex size-5 shrink-0 items-center justify-center rounded-full text-muted-foreground transition-colors hover:bg-muted hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
          data-documented={metadata.documented ? "true" : "false"}
        >
          <Info className="size-3.5" aria-hidden="true" />
        </button>
      </TooltipTrigger>
      <TooltipContent
        side="top"
        sideOffset={6}
        className="max-w-sm space-y-2 text-left text-xs text-pretty"
      >
        <p>
          <span className="font-semibold">What it does:</span>{" "}
          {metadata.purpose}
        </p>
        <p>
          <span className="font-semibold">Why it matters:</span>{" "}
          {metadata.importance}
        </p>
      </TooltipContent>
    </Tooltip>
  );
}
